import { UploadFile } from 'antd/lib/upload/interface';
import { ImageResponse } from '~/api/file';
import useReduxState from '~/hooks/useReduxState';

export type CachedImage = {
  isLoading: boolean;
  error: null | string;
  antdImage: UploadFile<any> | null;
  apiImage: ImageResponse | null;
};

export const cachedImageBase: CachedImage = {
  isLoading: false,
  error: null,
  antdImage: null,
  apiImage: null,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useImageCache = () => {
  return useReduxState<{
    [apiImageId: string]: CachedImage;
  }>('imagesCache', {});
};

export default useImageCache;
